import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/modal-social';
import '../general/modal';
import '../general/tabs';

import './index/slide-full';
import './index/slide-figure';
import './index/slide-game';
import './index/slide-lecture';
import './index/slide-materials';
import './index/get-started';


// WEBPACK FOOTER //
// ./src/js/pages/index.js